HTMLFormElement.prototype.checkValidity = function () {

    let elements = [...this.elements]
    let result = elements.every((e) => e.checkValidity ? e.checkValidity() : true)

    return result && this.reportValidity()

}